"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _locales = _interopRequireDefault(require("../locales.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Table = function Table(_ref) {
  var columns = _ref.columns,
      rows = _ref.rows,
      tableClass = _ref.tableClass,
      onHeaderClick = _ref.onHeaderClick,
      noRowsMessage = _ref.noRowsMessage,
      columnsConfig = _ref.columnsConfig,
      rowsStyle = _ref.rowsStyle,
      locale = _ref.locale;

  var readyRows = _react["default"].useMemo(function () {
    return rows.map(function (row) {
      // Allows to pass the column data directly or adding a css object for the row.
      var _row$rowData = row.rowData,
          rowData = _row$rowData === void 0 ? row : _row$rowData,
          _row$rowStyle = row.rowStyle,
          rowStyle = _row$rowStyle === void 0 ? rowsStyle : _row$rowStyle;
      var columns = Object.keys(rowData).map(function (key) {
        if (Object.prototype.hasOwnProperty.call(columnsConfig, key)) {
          return {
            // If column config includes the key but there is no render function prop, assume the function is passed directly
            value: columnsConfig[key].render ? columnsConfig[key].render(rowData[key]) : typeof columnsConfig[key] === 'function' ? columnsConfig[key](rowData[key]) : rowData[key],
            style: columnsConfig[key].style ? columnsConfig[key].style : {}
          };
        }

        return {
          value: rowData[key],
          style: {}
        };
      });
      return {
        columns: columns,
        rowStyle: rowStyle
      };
    });
  }, [rows, columnsConfig, rowsStyle]);

  return _react["default"].createElement("table", {
    className: tableClass
  }, _react["default"].createElement("thead", null, _react["default"].createElement("tr", null, columns.map(function (column, i) {
    return _react["default"].createElement("th", {
      key: i,
      onClick: function onClick() {
        return onHeaderClick(i);
      }
    }, column);
  }))), _react["default"].createElement("tbody", null, readyRows.map(function (row, i) {
    return _react["default"].createElement("tr", {
      key: i,
      style: row.rowStyle
    }, row.columns.map(function (column, j) {
      return _react["default"].createElement("td", {
        key: j,
        style: column.style
      }, column.value);
    }));
  }), rows.length === 0 && _react["default"].createElement("tr", null, _react["default"].createElement("td", {
    colSpan: "100%",
    style: {
      textAlign: 'center'
    }
  }, noRowsMessage ? noRowsMessage : _locales["default"][locale]['table-noentries']))));
};

Table.propTypes = {
  columns: _propTypes["default"].array,
  rows: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    data: _propTypes["default"].any,
    config: _propTypes["default"].any
  }), _propTypes["default"].any]),
  tableClass: _propTypes["default"].string,
  onHeaderClick: _propTypes["default"].func,
  noRowsMessage: _propTypes["default"].string,
  columnsConfig: _propTypes["default"].any,
  rowsStyle: _propTypes["default"].any,
  locale: _propTypes["default"].string
};
Table.defaultProps = {
  columns: [],
  rows: [],
  tableClass: 'table',
  onHeaderClick: function onHeaderClick(f) {
    return f;
  },
  noRowsMessage: '',
  columnsConfig: {},
  rowsStyle: {},
  locale: 'en'
};
var _default = Table;
exports["default"] = _default;